import { DefaultTheme } from "styled-components";

export const theme: DefaultTheme = {
  breakpoints: {
    xs: "0px",
    sm: "576px",
    md: "768px",
    lg: "992px",
    xl: "1200px",
  },
};
